// components/Reusablesteps/onboarding/MobileInputScreen.jsx
// Name (new patients only) + +91 phone input → "Send OTP" button.
//
// FIX: inputs were previously controlled by parent with single-char
// issue. This component is now fully self-contained with local state;
// it calls onNext(name, phone) only when the user taps Send OTP.

import React, { useState } from "react";
import styles from "./Onboarding.module.css";
import { SecureLine, PrimaryBtn, ProgressDots, ArrowRight } from "./onboardingTokens";

/**
 * MobileInputScreen
 *
 * @param {boolean}  isNew          - true = new patient (show name field)
 * @param {string}   initialName    - prefill value for name (optional)
 * @param {string}   initialPhone   - prefill value for phone (optional)
 * @param {function} onNext         - (name, phone) => void  called on submit
 * @param {number}   currentStep    - 0-based index for progress dots
 * @param {number}   totalSteps     - total dot count
 */
const MobileInputScreen = ({
  isNew         = false,
  initialName   = "",
  initialPhone  = "",
  onNext,
  currentStep   = 0,
  totalSteps    = 2,
}) => {
  const [name,  setName]  = useState(initialName);
  const [phone, setPhone] = useState(initialPhone);

  /* ── Validation ──────────────────────────────────────────── */
  const phoneDigits = phone.replace(/\D/g, "");
  const phoneOk     = phoneDigits.length === 10;
  const nameOk      = name.trim().length > 0;
  const canSubmit   = isNew ? (nameOk && phoneOk) : phoneOk;

  /* ── Handlers ────────────────────────────────────────────── */
  const handleNameChange = (e) => {
    // Allow any text; only block leading spaces
    const val = e.target.value;
    if (val.length === 0 || val[0] !== " ") {
      setName(val);
    }
  };

  const handlePhoneChange = (e) => {
    // Strip all non-digit chars, cap at 10 digits
    const digits = e.target.value.replace(/\D/g, "").slice(0, 10);
    setPhone(digits);
  };

  const handleSubmit = () => {
    if (!canSubmit) return;
    onNext?.(name.trim(), phone);
  };

  /* ── Render ──────────────────────────────────────────────── */
  return (
    <div className={styles.wrap}>
      <ProgressDots current={currentStep} total={totalSteps} />

      <div className={styles.centre}>

        <div style={{ textAlign: "center" }}>
          <h2 className={styles.question}>
            {isNew ? "Basic Info 😊" : "Welcome back! 👋"}
          </h2>
          <p className={styles.desc}>
            {isNew
              ? "Where should we send your personalised health insights?"
              : "Enter your mobile number to continue"}
          </p>
        </div>

        {/* <div className={styles.inputGroup}>


          {isNew && (
            <input
              className={styles.textInput}
              type="text"
              placeholder="Enter your name"
              value={name}
              onChange={handleNameChange}
              autoComplete="name"
              autoFocus
            />
          )}


          <div className={styles.phoneWrap}>
            <span className={styles.countryCode}>+91</span>
            <input
              className={styles.phoneInput}
              type="tel"
              inputMode="numeric"
              placeholder="10 digit mobile number"
              maxLength={10}
              value={phone}
              onChange={handlePhoneChange}
              autoComplete="tel-national"
            />
          </div>

          <PrimaryBtn
            label="Send OTP"
            onClick={handleSubmit}
            disabled={!canSubmit}
            icon={<ArrowRight />}
          />

        </div> */}
        <div className={styles.inputGroup}>

          {isNew && (
            <div className={styles.fieldGroup}>
              <label className={styles.label}>Full Name</label>
              <input
                className={styles.textInput}
                type="text"
                placeholder="Enter your name"
                value={name}
                onChange={handleNameChange}
                autoComplete="name"
                autoFocus
              />
            </div>
          )}


          <div className={styles.fieldGroup}>
            <label className={styles.label}>Mobile Number</label>

            <div className={styles.phoneWrap}>
              <span className={styles.countryCode}>+91</span>
              <input
                className={styles.phoneInput}
                type="tel"
                inputMode="numeric"
                placeholder="10 digit mobile number"
                maxLength={10}
                value={phone}
                onChange={handlePhoneChange}
                autoComplete="tel-national"
              />
            </div>
          </div>


          <br/>
          
          <PrimaryBtn
            label="Send OTP"
            onClick={handleSubmit}
            disabled={!canSubmit}
            icon={<ArrowRight />}
          />

        </div>
      </div>

      {/* <SecureLine /> */}
    </div>
  );
};

export default MobileInputScreen;
